module.exports = __webpack_public_path__ + "static/media/warning_fuel_level.1e80050b.svg";